import React from 'react';
import * as styles from './FeatureIntegrationPrompt.module.scss';
import installIntegration from './installIntegration';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import ExternalBrandLogo from '../../components/ExternalBrandLogo';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { IntegrationPlatformInfo } from '../../integrations/IntegrationPlatformInfo';

const INTEGRATION_FRAGMENT = gql(`
  fragment FeatureIntegrationPrompt_integration on Integration {
    id
    platform
  }
`);

interface FeatureIntegrationPromptProps {
  description?: string;
  feature?: string;
  integration: DocumentType<typeof INTEGRATION_FRAGMENT>;
  platformInfo: IntegrationPlatformInfo;
}

const FeatureIntegrationPrompt = ({
  description,
  feature,
  integration: { platform },
  platformInfo,
}: FeatureIntegrationPromptProps) => {
  const dispatch = useAppDispatch();
  const { icon, name } = platformInfo;

  const handleConnectClick = () =>
    installIntegration({
      dispatch,
      feature,
      platform,
      redirectUrl: window.location.href,
    });

  return (
    <div className={styles.authPrompt}>
      <div className={styles.authDescription}>{description}</div>
      <div className={styles.buttonContainer}>
        <Button variant="secondary" onClick={handleConnectClick}>
          <span className={styles.logoContainer}>
            <ExternalBrandLogo inline {...icon} height={14} />
          </span>
          Connect with {name}
        </Button>
      </div>
    </div>
  );
};

export default FeatureIntegrationPrompt;
